export default "__VITE_ASSET__9c4703a9__"